import React, { useState, useEffect } from 'react';

import Titulo from '@components/Titulo';
import { tablaEstylos, tablaTheadEstylos } from '@styles/tablaEstylos';
import { colors } from '@styles/colors';

import { cajaPrincipalStyle } from '@styles/cajaPrincipal';
import { cajaContenedorAdminStyle } from '@styles/cajaContenedorAdmin';

import { getBoldResponsesApi } from '@api/wp/recibos/recibosApi';
import { LAYOUT_COMPACT_MAX_PX } from '@utils/breakpoints';
import { DataCard, DataCardList, DataCardSection } from '@components/DataCard';

function Recibos() {
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);
  const [recibos, setRecibos] = useState([]);
  const [isCompact, setIsCompact] = useState(
    () => typeof window !== 'undefined' && window.innerWidth <= LAYOUT_COMPACT_MAX_PX
  );

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${LAYOUT_COMPACT_MAX_PX}px)`);
    const apply = () => setIsCompact(mq.matches);
    apply();
    mq.addEventListener('change', apply);
    return () => mq.removeEventListener('change', apply);
  }, []);

  // Cargar datos de recibos desde el backend
  useEffect(() => {
    cargar();
  }, []);


  const cargar = async () => {
    try {
      setCargando(true);
      setError('');
      const idPaciente = localStorage.getItem('idUsu');
      console.log( 'Paiente ', idPaciente )
      const response = await getBoldResponsesApi({ id_paciente: idPaciente });
      if (response.statusCode === 200 && response.result) {
        setRecibos(response.result);
      } else {
        setError('No se pudieron cargar los recibos');
      }
    } catch (e) {
      console.error('Error cargando recibos Bold:', e);
      setError('Error al cargar los recibos de pago');
    } finally {
      setCargando(false);
    }
  };

  // Eliminadas referencias a DataTables; se usa tabla simple con estilos globales

  return (
    <div id="cajaPrincipal"
      style={cajaPrincipalStyle}
    >
      <Titulo titulo="Recibos de pagos" subtitulo=""></Titulo>

      {/* Div central */}
      <div
        style={{
          ...cajaContenedorAdminStyle,
          ...(isCompact && {
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            marginLeft: 0,
            marginRight: 0,
            boxSizing: 'border-box',
          }),
        }}
      >
          <DataCardSection compact={isCompact} style={{ paddingBottom: '2vh' }}>
            {cargando ? (
              <div style={{ fontFamily: 'Inter', fontSize: '1.8vh', padding: '1vh', color: colors.secondaryButton }}>Cargando recibos...</div>
            ) : recibos.length > 0 ? (
              isCompact ? (
                <DataCardList>
                  {recibos.map((r, idx) => (
                    <DataCard
                      key={r?.id ?? idx}
                      rows={[
                        { label: 'Fecha de pago', value: r?.fecha ?? '' },
                        { label: 'Servicio', value: r?.nombre_espe ?? '' },
                        { label: 'Cita Id', value: r?.CitaID ?? '' },
                        {
                          label: 'Valor',
                          value: `$ ${r?.valor ? Number(r.valor).toLocaleString('es-CO') : '0'}`,
                        },
                        { label: 'Pasarela', value: 'BOLD' },
                        { label: 'Transacción', value: String(r?.idBold ?? '') },
                        { label: 'Estado', value: r?.estado ?? '' },
                      ]}
                    />
                  ))}
                </DataCardList>
              ) : (
                <table id="tabla-recibos" className="display dataTable" style={tablaEstylos}>
                  <thead style={tablaTheadEstylos}>
                    <tr>
                      <th>Fecha de pago</th>
                      <th>Servicio</th>
                      <th>Cita Id</th>
                      <th style={{ textAlign: 'right' }}>Valor</th>
                      <th>Pasarela</th>
                      <th>Transacción</th>
                      <th>Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {recibos.map((r, idx) => (
                      <tr key={r?.id ?? idx}>
                        <td>{r?.fecha ?? ''}</td>
                        <td>{r?.nombre_espe ?? ''}</td>
                        <td>{r?.CitaID ?? ''}</td>
                        <td style={{ textAlign: 'right' }}>$ {r?.valor ? Number(r.valor).toLocaleString('es-CO') : '0'}</td>
                        <td>BOLD</td>
                        <td>{r?.idBold ?? ''}</td>
                        <td>{r?.estado ?? ''}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )
            ) : (
              <div style={{
                fontFamily: 'Inter',
                fontSize: '1.8vh',
                padding: '1vh',
                color: colors.secondaryButton,
                backgroundColor: isCompact ? colors.white : undefined,
                borderRadius: isCompact ? '1.2vh' : undefined,
                boxShadow: isCompact ? '0 0.4vh 1.2vh rgba(0,0,0,0.06)' : undefined,
              }}
              >
                No hay recibos disponibles
              </div>
            )}
          </DataCardSection>

      </div>

      {/* Mensaje de error */}
      {error && (
        <div style={{
          marginTop: '2vh',
          marginLeft: isCompact ? 'clamp(8px, 2vw, 18px)' : '6vh',
          marginRight: isCompact ? 'clamp(8px, 2vw, 18px)' : undefined,
          color: colors.error,
          fontSize: '1.6vh',
          fontFamily: 'Inter',
          boxSizing: 'border-box',
        }}>
          {error}
        </div>
      )}

    </div>
  );
}
export default Recibos;
